import React from 'react';
import { Modal } from 'antd';

interface SoldActionModalProps {
  visible: boolean;
  onCancel: () => void;
  handleModalOk: () => void;
  confirmLoading: boolean;
}

const SoldActionModal: React.FC<SoldActionModalProps> = ({ visible, onCancel, confirmLoading, handleModalOk }) => {
  return (
    <Modal
      title="Solder en espèces/chèque ?"
      visible={visible}
      onCancel={onCancel}
      onOk={handleModalOk}
      confirmLoading={confirmLoading}
      okText="Confirmer"
      cancelText="Annuler"
      destroyOnClose={true}
    >
      <p>Êtes-vous sûr de vouloir solder en espèces/chèque ?</p>
    </Modal>
  );
};
export default SoldActionModal;
